import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Right from '../../right/Right';
import './MealPlanner.css';
import Cookies from "js-cookie";
import Service from '../../service/Service';
import * as actions from './actions';
import withContext from "../../../withContext";

const service = new Service();

class MealPlannerFeedback extends Component {
    constructor(props) {
        super(props);
        let window_width = 1024;
        let initialData = [];
        let isLoggedin = false;
        let childInfo = {};
        let isApp = '';
        if (global.ftk == '') {
            isLoggedin = false
        } else {
            isLoggedin = true
        }
        if (this.props.location.search.includes('from=app')) {
            isApp=true;
        }
        this.state = {
            initialData: initialData,
            window_width: window_width,
            isLoggedin: isLoggedin,
            textAreaValue: "",
            metaTitle: "Feedback: Baby & Toddlers Meal Plans - FirstCry Parenting",
            isApp: isApp
        }
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.setState({ window_width: window.innerWidth, windowWidth: window.outerWidth });
        // console.log("windowWidth--", window.outerWidth);
        if(this.state.isApp){
            document.querySelector('.main-container').style.background="#eee";
            // document.querySelector('.data-container').style.minHeight = "unset";
            document.querySelector('.sub-container').style.marginBottom = "0";
            // var scheight = screen.height;
            // document.querySelector('.main-container').style.height = scheight + "px";
            var minheightdata = window.innerHeight - 50;
            document.querySelector('.data-container').style.minHeight = minheightdata + "px";
            actions.loadCallbackFile();
        }
        setTimeout(()=>{
            var user_mailId = "";
            if(global.userAry['EmailAddress'].trim()){
                user_mailId=global.userAry['EmailAddress'].trim();
                if(user_mailId.split('.')[user_mailId.split('.').length-1]=="com"){
                    document.getElementById("usermailId").value=user_mailId;
                }
            }
            if(user_mailId == ""){
                // _$FC_LoginInfo$_
                user_mailId = Cookies.get("mealLogin").trim();
                if(user_mailId.split('.')[user_mailId.split('.').length-1]=="com"){
                    document.getElementById("usermailId").value=user_mailId;
                }
            }
        },500);
    }

    handleChange(event) {
        if(event.target.value.length <= 500){
            this.setState({ textAreaValue: event.target.value });
        }
        if(event.target.value.length <= 10){
            document.getElementById("errfeedbacksubmit").innerHTML = "Please enter minimum 10 characters."; 
            
        }else{
            document.getElementById("errfeedbacksubmit").innerHTML = ""; 
        }
    }
   
    submitFeedback(event) {
        if (global.ftk != '') {
            var val = document.getElementById("feedbacktext").value;
            var userMailId = document.getElementById("usermailId").value;
            var splitarryMailId = userMailId.split(".");
            if (val.length <= 10 || val.trim() == '' || userMailId == '' || !((/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(userMailId)) && (splitarryMailId[splitarryMailId.length - 1] == "com" || splitarryMailId[splitarryMailId.length - 1] == "COM"))) {
                if (userMailId == '') {
                    var not = "Please Enter Email ID";
                } else if (!((/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(userMailId)) && (splitarryMailId[splitarryMailId.length - 1] == "com" || splitarryMailId[splitarryMailId.length - 1] == "COM"))) {
                    var not = "Please Enter Valid Email Id";
                }else if(val.length <= 10){
                    var not = "Please enter minimum 10 characters.";
                }else {
                    var not = "Please Enter Your Feedback";
                }

                document.getElementById("errfeedbacksubmit").innerHTML = not;

                setTimeout(() => {
                    document.getElementById("errfeedbacksubmit").innerHTML = "";
                }, 3000);

                return !1
            } else {
                var postData = {
                    "feedbacktext": val,
                    "userId": global.uID,
                    "userEmailId": userMailId
                }
                var url = global.api_ci_url + "MealPlanner/mealSendFeedBack";
                service.postServiceCall(url, postData).then((json) => {
                    if (json.msg == "1") {
                        var not = "Feedback Successfully Saved";
                        service.showAlert(not);
                        window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/");
                    } else {
                        var not = "Unsuccess";
                        service.showAlert(not);
                    }
                    service.hideLoader();
                }).catch((error) => {
                    console.error(error);
                    service.hideLoader();
                });
            }
        } else {
            if (this.state.isApp) {
                actions.loginCallBack1();
            } else {
                service.showAlert("Please Login");
                window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL);
                return false;
            }
        }

    }

    domClick(event) {
        console.log("event Dom========>", event.target)
        if (event.target.classList.contains('share-overlay')) {
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
        }
    }

    render() {
        return (
            <main className="main-container meal-planner meal-Feedback">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                {!this.state.isApp && 
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={global.redirect_url + "tools/baby-meal-plan"} className="R11_9e">Baby Meal Planner</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Feedback</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Feedback</h1>
                </div>
                }
                {this.state.isApp &&
                    <div className="app-header">
                            <span data-icon-font="s" className="icon" onClick={() => onBackPressed()}></span>
                        <span className="M16_pink">Feedback</span>
                    </div>
                }
                {/* <div className="sub-container left">
                    <div className="data-container left">
                        <div className="feedback_sec gr_info">
                            <textarea placeholder="Your feedback is valuable to us which will help us serve you better.Share your feedback about our Meal Planner here in 250 characters." maxLength="250" id="feedbacktext" name="feedbacktext" spellcheck="false"></textarea>
                            <div className="view_gr_tr askB_1" id="feedback-submit">
                                <span className="B14_white">Submit</span>
                                <span className="icon feedicon" data-icon-font=""></span>
                            </div>
                            <span id="errfeedbacksubmit"></span>
                        </div>
                    </div>                   
                </div> */}
                <div className="sub-container left" style={this.state.isApp ? { marginTop: '50px' } : {}}>
                    <div className="data-container left">
                        <div className="useremailId">
                            <textarea placeholder="Add Email Address" maxLength="250" id="usermailId" name="usermailId" spellCheck="false" />
                        </div>
                        <div className="feedback_sec gr_info">
                            <textarea placeholder="Your feedback is valuable to us which will help us serve you better.Share your feedback about our Meal Planner here in 500 characters." maxLength="500" id="feedbacktext" name="feedbacktext" spellCheck="false"
                                value={this.state.textAreaValue}
                                onChange={this.handleChange}
                            />
                            <div className="view_gr_tr askB_1" id="feedback-submit" onClick={(e) => this.submitFeedback(e)}>
                                <span className="B14_white">Submit</span>
                                <span className="icon" data-icon-font="&#xe00d;"></span>
                            </div>
                            <span id="errfeedbacksubmit" className="left"></span>
                        </div>
                    </div>
                </div>
                <div className="new-right-sect">
                    <Right url={this.props.location.pathname} />
                </div>
            </main>
        )
    }
}

export default withContext(MealPlannerFeedback);
